"use strict";
// generated_funding_request.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: v4_1.z.string().describe('Credit facility slug'),
    description: v4_1.z.string().describe('Description'),
    fundingSubmissionComponentsArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Use if passing known funding request amounts + target dates. Created funding request will automatically be submitted. CSV with 3 columns: "type" (i.e. funding request component type), "totalAmount", "targetFundingDate".'),
});
exports.nodeType = 'file_generatedFundingRequest';
exports.IntermediateRecordConfigSchema = v4_1.z.object({
    tapeDescription: v4_1.z.string(),
    lenderVerificationConfig: tape_builder_base_1.LenderVerificationConfigSchema.optional(),
    fundingSubmissionComponentsArtifactSlug: v4_1.z.string().optional(),
});
exports.artifactType = 'fundingRequest';
//# sourceMappingURL=types.js.map